import { render, staticRenderFns } from "./Factories.vue?vue&type=template&id=0930f652&scoped=true&"
import script from "./Factories.vue?vue&type=script&lang=js&"
export * from "./Factories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0930f652",
  null
  
)

export default component.exports